import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";
// import axios from "axios";
import { API_BASE_URL } from "../Config/Config";
import Swal from "sweetalert2";
import * as bootstrap from "bootstrap";

const EditClient = ({
  record,
  subscriptionType = [],
  licenseTypeOptions = [],
  subscriptionStatusOptions = [],
  getClients,
}) => {

   console.log(licenseTypeOptions, "licenseTypeOptions");

   console.log(record,"recordddddddddddddddddddddddddddddddddddddddddddddddddd")
 


  const [loading, setLoading] = useState(false);

  const [clientData, setClientData] = useState({
 
    SuperId: "",
    OrgName: "",
    Email: "",
    MobileNumber: "",
    SubscribedOn: "",
    Address: "",
    SubscriptionType: null,
    LicenseType: null,
    SubscriptionStatus: null,
  });

  console.log(clientData,"clientData............")

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";
  
    const [day, month, year] = dateStr.split("-");
  
    return `20${year}-${month}-${day}`;
  };

  useEffect(() => {
    if (record) {
      setClientData({
       
        SuperId: record?.SuperId || "",
        OrgName: record?.OrgName || "",
        Email: record?.PrimaryEmailAddr || "",
        MobileNumber: record?.PrimaryMobile || "",
        SubscribedOn: formatDateForInput(record?.SubscribedOn),
        Address: record?.Address || "",
        SubscriptionType: record?.SubscriptionType || null,
        LicenseType: record?.LicenseType || null,
        SubscriptionStatus: record?.SubscribeStatus || null,
      });
    }
  }, [record]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setClientData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const updateClient = async () => {
    try {
      setLoading(true);
  
      const payload = {
        ...clientData,
      };

      console.log(payload,"payload...........")
  
      const response = await fetch(
        `${API_BASE_URL}api/org/addorg`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
  
      const data = await response.json();
  
      if (data?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Client updated successfully",
          confirmButtonText: "OK",
        }).then(() => {
          const modalElement = document.getElementById("EditClient");

          const modal = bootstrap.Modal.getInstance(modalElement);

          modal.hide();

          document
            .querySelectorAll(".modal-backdrop")
            .forEach((el) => el.remove());

          document.body.classList.remove("modal-open");

          document.body.style = "";
        });
        getClients();
  
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data?.message || "Failed to update client",
          confirmButtonText: "OK",
        });
      }
  
    } catch (error) {
      console.log(error);
  
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong",
        confirmButtonText: "OK",
      });
  
    } finally {
      setLoading(false);
    }
  };

  console.log(record, "rrrrrrrrrrrrrrrrrrrrrrrrr");
  return (
    <div className="modal fade" id="EditClient">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">
              Edit Client{" "}
              <span style={{ color: "orange" }}>{record?.OrgName}</span>
            </h4>
            <button
              id="closeAddCompanyModal"
              type="button"
              className="btn-close custom-btn-close p-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              // onClick={() => resetClientForm()}
            >
              <i className="ti ti-x" />
            </button>
          </div>
          <form>
            <div className="modal-body pb-0">
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">
                      Super ID <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="SuperId"
                      value={clientData.SuperId}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter SuperId"
                      disabled
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">
                      Cilent Name <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="OrgName"
                      value={clientData.OrgName}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter Name"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      name="Email"
                      value={clientData.Email}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter Email"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">
                      Mobile Number <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="text"
                      name="MobileNumber"
                      value={clientData.MobileNumber}
                      onChange={handleInputChange}
                      className="form-control"
                      placeholder="Enter Mobile number"
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Subscribed On</label>
                    <input
                      type="date"
                      name="SubscribedOn"
                      value={clientData.SubscribedOn}
                      onChange={handleInputChange}
                      className="form-control"
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3 ">
                    <label className="form-label">
                      Subscription Type
                      <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="w-100"
                      style={{ width: 100, height: 38 }}
                      options={subscriptionType}
                      placeholder="Choose"
                      value={clientData.SubscriptionType}
                      onChange={(value) => {
                        setClientData({
                          ...clientData,
                          SubscriptionType: value,
                        });
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                      popupClassName=""
                      dropdownStyle={{ zIndex: 9999 }}
                      dropdownRender={(menu) => (
                        <div style={{ zIndex: 9999, position: "relative" }}>
                          {menu}
                        </div>
                      )}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">
                      License Type <span className="text-danger">*</span>
                    </label>

                    <Select
                      className="w-100"
                      style={{ width: 100, height: 38 }}
                      options={licenseTypeOptions}
                      placeholder="Choose"
                      value={clientData.LicenseType}
                      onChange={(value) => {
                        setClientData({
                          ...clientData,
                          LicenseType: value,
                        });
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Subscription Status</label>

                    <Select
                      className="w-100"
                      style={{ width: 100, height: 38 }}
                      options={subscriptionStatusOptions}
                      placeholder="Choose"
                      value={clientData.SubscriptionStatus}
                      onChange={(value) => {
                        setClientData({
                          ...clientData,
                          SubscriptionStatus: value,
                        });
                      }}
                      getPopupContainer={(trigger) => trigger.parentNode}
                    />
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="mb-3">
                    <label className="form-label">Address</label>
                    <textarea
                      className="form-control"
                      rows={2}
                      name="Address"
                      value={clientData.Address}
                      onChange={handleInputChange}
                      placeholder="Enter Address"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light me-2"
                data-bs-dismiss="modal"
                //   onClick={() => resetClientForm()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={updateClient}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
EditClient.propTypes = {
  record: PropTypes.object,
  serviceType: PropTypes.array,
  productTypeOptions: PropTypes.array,
  subscriptionType: PropTypes.array,
  licenseTypeOptions: PropTypes.array,
  processingType: PropTypes.array,
  subscriptionStatusOptions: PropTypes.array,
  getClients: PropTypes.func,
};
export default EditClient;
